import Button from "../../components/common/button/Button";
import TitleUpdater from "../../components/common/title/TitleUpdater";
import { useLocalizedNavigate } from "../../hooks/useLocalizedNavigate";
import styles from "./NotFound.module.scss";
import notification from "../../assets/images/store/notification.png";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation("translation");

  const navigate = useLocalizedNavigate();
  return (
    <div className={styles.not_found_page}>
      <TitleUpdater title={t("not_found_page")} />
      <div className={styles.not_found_image}>
        <div className={styles.content}>
          <div className={styles.notification}>
            <img src={notification} alt="Notification" />
          </div>
          <p className={styles.oops}>Oops!</p>
          <p>{t("not_found_page")}</p>
          <div className={styles.not_found_btn}>
            <Button onClick={() => navigate("/")}>{t("back_home")}</Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
